/* © 2023 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */

import React from 'react'
import Header from '../header'
import TitledCard, { ITitledCardProps } from '../card'
import classnames from 'classnames'
import useDisableZoomSite from '../../utils/disableZoomHook'
import LeftImg from './left.svg'
import RightImg from './right.svg'
import { StyledLayout } from './styles'

interface ILayoutProps {
  cardProps?: ITitledCardProps
  children?: React.ReactElement
  scroll?: boolean
  className?: string
}

export const Layout = ({ cardProps, children, scroll = true, className }: ILayoutProps): React.ReactElement => {
  useDisableZoomSite()

  return (
    <StyledLayout className={classnames('Layout-root', 'scroll', className)}>
      <img className="Layout-leftFire" src={LeftImg} alt="" />
      <img className="Layout-rightFire" src={RightImg} alt="" />
      <div className="Layout-content" role="main">
        {cardProps && <TitledCard header={<Header />} {...cardProps} />}
        {children}
      </div>
    </StyledLayout>
  )
}

export default Layout
